import { Navigate, useLocation, useNavigationType } from "react-router-dom";

const MenuProtectedRoute = ({ children, allowRefresh = false }) => {
  const location = useLocation();
  const navigationType = useNavigationType(); // 👈 KEY
  const accessToken = sessionStorage.getItem("accesstoken");

  // 1️⃣ Auth check
  if (!accessToken) {
    return <Navigate to="/" replace />;
  }

  // Allow an explicitly enabled route to survive a browser refresh. React
  // Router reports refresh as POP, while the original menu-entry state stays
  // in browser history. A manually typed URL has no fromMenuClick state.
  const enteredFromMenu = Boolean(location.state?.fromMenuClick);
  const isMenuNavigation = navigationType === "PUSH" && enteredFromMenu;
  const isAllowedRefresh =
    allowRefresh && navigationType === "POP" && enteredFromMenu;

  if (!isMenuNavigation && !isAllowedRefresh) {
    return <Navigate to="/home/menus" replace />;
  }

  return children;
};

export default MenuProtectedRoute;
